/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React from "react";
import { View } from "react-native";
import { TableCell, TableRow } from "@material-ui/core";

import { Text, UserCell } from "UpduoLibrary";
import {
  skaleLightBlue,
  skaleCellRed,
  skaleCellYellow,
  skaleCellGreen,
  skaleWebTextLightGray,
  colorWithOpacity,
} from "config/UpduoColors";

export default function ProgressRow({ rowData, skillList }) {
  const _handleGenerateMasteryString = (value) => {
    let result = "Not Started";
    switch (value) {
      case 3:
        result = "Master";
        break;
      case 2:
        result = "Proficient";
        break;
      case 1:
        result = "Novice";
        break;
      case -1:
        result = "Taught Only";
        break;
      default:
        break;
    }
    return result;
  };

  const _handleGenerateMasteryColor = (value: number) => {
    let cellColor = "";
    switch (value) {
      case 3:
        cellColor = skaleCellGreen;
        break;
      case 2:
        cellColor = skaleCellYellow;
        break;
      case 1:
        cellColor = skaleCellRed;
        break;
      case -1:
        cellColor = skaleLightBlue;
        break;
      default:
        return "transparent";
    }
    return colorWithOpacity(cellColor, value > 0 ? 0.4 : 0.2);
  };

  // Row cells (TableRowColumn components) must be in an array,
  // so that we can push an indeterminate number of skill mastery cells
  const allRowCells = [
    <TableCell key={0} />,
    <TableCell key={1}>
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <UserCell user={rowData} />
      </View>
    </TableCell>,
    <TableCell key={2}>
      <View style={{ alignItems: "center" }}>
        <Text>{rowData.score}</Text>
      </View>
    </TableCell>,
    <TableCell key={3}>
      <View style={{ alignItems: "center" }}>
        <Text> {rowData.session_count}</Text>
      </View>
    </TableCell>,
  ];
  // Generate mastery level values for each current active org skill
  const masteryValues: number[] = [];
  skillList.forEach((item) => {
    const masteryEntry = rowData.mastery.find((mastery_skill) => {
      return mastery_skill.id === item.id;
    });
    if (masteryEntry) {
      masteryValues.push(masteryEntry.mastery_level);
    }
  });
  // skillsMastered sum (ignoring taught-only negative values):
  // Master=1, Proficient=0.67, Novice=0.33
  let skillsMastered: number | string = Math.floor(
    masteryValues.length > 0
      ? masteryValues.reduce((a, b) => Math.max(0, a) + Math.max(0, b))
      : 0
  );
  skillsMastered = skillsMastered / 3;
  if (skillsMastered % 1 !== 0) {
    skillsMastered = skillsMastered.toFixed(2);
  }
  allRowCells.push(
    <TableCell key={4}>
      <View style={{ alignItems: "center" }}>
        <Text>{skillsMastered}</Text>
      </View>
    </TableCell>
  );
  //Mastery of each skill
  masteryValues.forEach((item, itemIndex) => {
    allRowCells.push(
      <TableCell
        style={{
          padding: 0,
          backgroundColor: _handleGenerateMasteryColor(item),
          alignItems: "center",
          minWidth: 80,
          maxWidth: 80,
        }}
        key={5 + itemIndex}
        align={"center"}
      >
        <View
          style={{
            flex: 1,
            height: "100%",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Text
            style={{
              fontStyle: item > 0 ? undefined : "italic",
              color:
                item > 0
                  ? undefined
                  : colorWithOpacity(skaleWebTextLightGray, 0.25),
            }}
          >
            {_handleGenerateMasteryString(item)}
          </Text>
        </View>
      </TableCell>
    );
  });
  return (
    <TableRow hover={true} key={0}>
      {allRowCells}
    </TableRow>
  );
}
